import Splide from '@splidejs/splide';

var carouselClassName = 'carousel__slider';

var elms = document.getElementsByClassName( 'splide' );

if (elms.length) {

	for ( var i = 0; i < elms.length; i++ ) {
		new Splide( elms[ i ], {
			perPage: 3,
			gap: '1.5rem',
			pagination: false,
			padding: {
				left: '4rem',
				right: '4rem',
			},
			breakpoints: {
				'1297': {
					perPage: 2,
				},
				'767': {
					perPage: 1,
					padding: {
						left: '2rem',
						right: '8rem',
					},
					focus    : 'center',
				},
			}
		} ).mount();
	}

}
